export default __webpack_public_path__ + "static/media/aucune.a4e52be7.svg";